import React from 'react';
import styled from "styled-components";

const SGrammarAlfabeto = styled.div`
  flex: 1;
  padding: 5px 20px;
  td {
    padding: 5px;
  }
`;

const GrammarAlfabeto = () => {
  return (
    <SGrammarAlfabeto>
  <h5>Alfabet (Alfabeto)</h5>

<table>
<tr><td width="7%"><b>Litera</b></td><td width="13%"><b>Nazwa</b></td>
    <td width="30%"><b>Przykłady</b></td><td width="55%"><b>Wymowa, komentarz</b></td></tr>

<tr><td><h5>a</h5></td>
<td><i>a</i></td>
<td><b>a</b>lto (czyt. <u>al</u>to) - wysoki<br/>
el <b>a</b>lm<b>a</b> (czyt. el <u>al</u>ma) - dusza</td>
<td>Jak w języku polskim.</td></tr>

<tr><td align="center"><h5>b</h5></td>
<td><i>be</i></td>
<td><b>b</b>e<b>b</b>er (czyt. <i>b</i>e<i>b</i><u>er</u>) - pić<br/>
el <b>b</b>arco (czyt. el <i><u>b</u></i><u>ar</u>ko) - statek<br/>
*b - patrz opis obok</td>
<td>Dźwięk pośredni między polskimi <i>b </i>oraz <i>w</i>.</td></tr>

<tr><td align="center"><h5>c</h5></td>
<td><i>ce</i></td>
<td>la <b>c</b>asa (czyt. la <u>ka</u>sa) - dom<br/>
<b>c</b>ono<b>c</b>er (czyt. kono<i><u>th</u></i><u>er</u>) - znać<br/>
gra<b>c</b>ias (czyt. <u>gra</u><i>th</i>ias) - dziękuję<br/>
la le<b>cc</b>ión (czyt. la lek<i><u>th</u></i><u>jon</u>) - lekcja<br/>
*th - patrz opis obok</td>
<td>Generalnie jak polskie <i>k</i>; wyjątkiem jest sytuacja, gdy występuje
po niej samogłoska <i>e</i> lub <i>i</i> (<i>ce</i>, <i>ci</i>) - wtedy
wymawia się jak angielskie <i>th</i> w wyrazie <i>think</i> (język należy
umieścić między zębami).<br/>
W hiszpańskiej Andaluzji, na Wyspach Kanaryjskich oraz w
Ameryce Łacińskiej zamiast tego skomplikowanego dźwięku używa się po prostu
<i>s</i>. Tak więc wszelkie wyrazy zawierające <i>ce </i>lub <i>ci</i>
wymawia się jak <i>se</i> oraz <i>si</i>.</td></tr>

<tr><td align="center"><h5>ch</h5></td>
<td><i>che</i></td>
<td>el co<b>ch</b>e (czyt. el <u>ko</u>cie) - samochód<br/>
la no<b>ch</b>e (czyt. la <u>no</u>cie) - noc</td>
<td>Dźwięk pośredni między polskimi <i>cz</i> oraz <i>ć</i>.<br/><br/>
Do niedawna uważana za jedną z liter alfabetu, natomiast obecnie jedynie za
złożenie spółgłosek o jednym dźwięku.</td></tr>

<tr><td align="center"><h5>d</h5></td>
<td><i>de</i></td>
<td>el <b>d</b>e<b>d</b>o (czyt. el <u>de</u>do) - palec<br/>
la pare<b>d</b> (czyt. la pa<u>re</u> - ściana<br/>
*ed - patrz opis obok</td>
<td>Jak w języku polskim. Gdy znajduje się na końcu wyrazu, prawie nie
jest wymawiana: np. <i>usted</i> (pan, pani) czyta się <i>us<u>te</u>d</i>,
przygotowując na końcu język jak do wymowy <i>d</i>, ale bez wydawania
tego dźwięku.<br/>
W Madrycie jest charakterystyczne wymawianie końcowego <i>d</i>
identycznie jak hiszpańską literę <i>z</i> (czyli jak angielskie
<i>th</i> w wyrazie <i>think</i>), tak więc np. Madrid czyta się jak
<i>mad<u>rith</u></i>.</td></tr>

<tr><td align="center"><h5>e</h5></td>
<td><i>e</i></td>
<td><b>e</b>l <b>e</b>j<b>e</b>mplo (czyt. el e<u>hem</u>plo) - przykład<br/>
<b>e</b>l <b>e</b>goísmo (czyt. el ego<u>jis</u>mo) - egoizm</td>
<td>Jak w języku polskim.</td></tr>

<tr><td align="center"><h5>f</h5></td>
<td><i>de</i></td>
<td><b>f</b>eliz (czyt. fe<u>li<i>th</i></u>) - szczęśliwy/a<br/>
<b>f</b>eo (czyt. <u>fe</u>o) - brzydki</td>
<td>Jak w języku polskim.</td></tr>

<tr><td align="center"><h5>g</h5></td>
<td><i>ge</i></td>
<td>el <b>g</b>ato (czyt. el <u>ga</u>to) - kot<br/>
el án<b>g</b>el (czyt. el <u>an</u>hel) - anioł<br/>
<b>g</b>irar (czyt. hi<u>rar</u>) - skręcać<br/>
el <b>g</b>ueto (czyt. el <u>ge</u>to) - getto<br/>
el <b>g</b>uía (czyt. el <u>gi</u>ja) - przewodnik<br/>
la ci<b>g</b>üeña (czyt. la <i>th</i>i<u>głe</u>nia) - bocian</td>
<td>Generalnie jak polskie <i>g</i>; wyjątkiem, podobnie jak przy literze
<i>c</i>, jest sytuacja, gdy występuje po niej samogłoska <i>e </i>lub
<i>i</i> (<i>ge</i>, <i>gi</i>) - wtedy wymawia się podobnie jak polskie
<i>h</i>, tyle że bardziej charczące, gardłowe. Tak więc na przykład słowo
<i>la gente</i> (ludzie), wymawia się jak polskie <i><u>hen</u>te </i>
(nie zapominając o charakterystycznym 'charczeniu'). Aby uzyskać
dźwięk, który w języku polskim czyta się jako <i>ge </i>lub <i>gi</i>,
umieszcza się w środku literę <i>u</i> (<i>gue</i>, <i>gui</i>). <i>U</i>
nie jest w tej sytuacji w ogóle wymawiane - służy tylko rodzieleniu liter,
by uzyskać inny dźwięk. Tak więc przykładowo słowo <i>la guerra</i>
(wojna) czyta się jak polskie <i><u>ger</u>ra</i>.<br/>
Pozostaje jeszcze dopowiedzieć jak w hiszpańskim zapisać dźwięk, który po
polsku oznaczyłoby się jako <i>głe</i>czy też <i>głi</i>. Otóż w tej
sytuacji (co zdarza się dosyć rzadko), umieszcza się nad literą <i>u</i>
dwie kropki: <i>güe</i>, <i>güi</i>. Zaznacza się w ten sposób,
iż litera <i>u</i>, mimo że znajduje się pomiędzy <i>g</i> oraz <i>e</i>
lub <i>i</i>, musi zostać przeczytana.</td></tr>

<tr><td align="center"><h5>h</h5></td>
<td><i>hache</i></td>
<td><b>h</b>ablar (czyt. a<i>b</i><u>lar</u>) - rozmawiać<br/>
<b>h</b>ola (czyt. <u>o</u>la) - cześć</td>
<td>Jest w języku hiszpańskim literą niemą, nigdy nie jest wymawiana.</td></tr>

<tr><td align="center"><h5>i</h5></td>
<td><i>i</i></td>
<td><b>i</b>ntel<b>i</b>gente (czyt. inteli<u>hen</u>te) - inteligentny/a<br/>
la pel<b>í</b>cula (czyt. la pe<u>li</u>kula) - film<br/>
com<b>í</b>amos (czyt. ko<u>mi</u>jamos) - jedliśmy</td>
<td>Jak w języku polskim.<br/><br/>
Gdy jest nad tą literą zaznaczony akcent, czyta się często jak polskie <i>ij</i>:
np. <i>el día</i> (dzień) wymawia się jak polskie <i><u>di</u>ja</i>.</td></tr>

<tr><td align="center"><h5>j</h5></td>
<td><i>jota</i></td>
<td><b>j</b>oven (czyt. <u>ho</u><i>b</i>en) - młody/a<br/>
el <b>j</b>abón (czyt. el ha<i><u>b</u></i><u>on</u>) - mydło</td>
<td>Podobnie jak polskie <i>h</i>, ale bardziej charczące, gardłowe
(identycznie jak w opisanym wyjątku przy literze <i>g</i>).</td></tr>

<tr><td align="center"><h5>k</h5></td>
<td><i>ka</i></td>
<td>el <b>k</b>ilo (czyt. el <u>ki</u>lo) - kilogram<br/>
el <b>k</b>iwi (czyt. el <u>ki</u>łi) - kiwi</td>
<td>Jak w języku polskim. Używana jedynie w wyrazach pochodzenia greckiego
oraz w innych zapożyczeniach.</td></tr>

<tr><td align="center"><h5>l</h5></td>
<td><i>ele</i></td>
<td><b>l</b>a <b>l</b>una (czyt. la <u>lu</u>na) - księżyc<br/>
<b>l</b>a pe<b>l</b>ota (czyt. la pe<u>lo</u>ta) - piłka</td>
<td>Jak w języku polskim.</td></tr>

<tr><td align="center"><h5>ll</h5></td>
<td><i>elle</i></td>
<td>e<b>ll</b>a (czyt. <u>e</u><i>dzi</i>a) - ona<br/>
la <b>ll</b>uvia (czyt. la <i><u>dzi</u></i><u>u</u><i>b</i>ia) - deszcz<br/>
*dzi - patrz opis obok </td>
<td>Do niedawna uważana za jedną z liter alfabetu, natomiast obecnie jedynie
za złożenie spółgłosek o jednym dźwięku. dźwięk trudny do wytłumaczenia,
pośredni między polskimi <i>j</i> oraz <i>ź</i>. Można też go opisać jako
bardzo miękkie <i>dź</i>.<br/>
W Ameryce Południowej (zwłaszcza w Argentynie), można się spotkać z twardszą
wymową - coś między polskimi <i>ź</i> oraz <i>ż</i>.</td></tr>

<tr><td align="center"><h5>m</h5></td>
<td><i>eme</i></td>
<td>a <b>m</b>ujer (czyt. la mu<u>her</u>) - kobieta<br/>
la <b>m</b>ano (czyt. la <u>ma</u>no) - ręka</td>
<td>Jak w języku polskim.</td></tr>

<tr><td align="center"><h5>n</h5></td>
<td><i>ene</i></td>
<td><b>n</b>egro (czyt. <u>neg</u>ro) - czarny<br/>
la <b>n</b>ieve (czyt. la <u>nie</u><i>b</i>e) - śnieg</td>
<td>Jak w języku polskim.</td></tr>

<tr><td align="center"><h5>ñ</h5></td>
<td><i>eñe</i></td>
<td>espa<b>ñ</b>ol (czyt. espa<u>niol</u>) - hiszpański<br/>
el ba<b>ñ</b>o (czyt. el <i><u>b</u></i><u>a</u>nio) - łazienka</td>
<td>Jak polskie <i>ń</i>.</td></tr>

<tr><td align="center"><h5>o</h5></td>
<td><i>o</i></td>
<td>el <b>o</b>j<b>o</b> (czyt. el <u>o</u>ho) - oko<br/>
 el <b>o</b>rdenad<b>o</b>r (czyt. el ordena<u>dor</u>) - komputer</td>
<td>Jak w języku polskim.</td></tr>

<tr><td align="center"><h5>p</h5></td>
<td><i>pe</i></td>
<td>la <b>p</b>uerta (czyt. la <u>płer</u>ta) - drzwi<br/>
el <b>p</b>elo (czyt. el <u>pe</u>lo) - włosy </td>
<td>Jak w języku polskim.</td></tr>

<tr><td align="center"><h5>q</h5></td>
<td><i>cu</i></td>
<td>por<b>q</b>ue (czyt. <u>por</u>ke) - ponieważ<br/>
<b>q</b>uerer (czyt. ke<u>rer</u>) - kochać<br/>
la <b>q</b>uímica (czyt. la <u>ki</u>mika) - chemia</td>
<td>Jak polskie <i>k</i>. Zawsze występuje po niej litera <i>u</i>, która
jednak nigdy nie jest wymawiana. Używana jest do uzyskania dźwięków <i>que</i>
oraz <i>qui</i> (czyt. <i>ke</i> oraz <i>ki</i>). Tak więc na przykład słwo
<i>el queso</i> (ser) czyta się <i><u>ke</u>so</i>.<br/>
Niewielkim wyjątkiem jest tu kilka słów obcego pochodzenia: np. <i>quark</i>
czy <i>quórum</i>, gdzie litera <i>u</i> jest wymawiana, a więc czyta się
odpowiednio: <i>kłark</i>, <i><u>kło</u>rum</i>.</td></tr>

<tr><td align="center"><h5>r</h5></td>
<td><i>erre</i><br/>(czasami nazywana też <i>ere</i>)</td>
<td>co<b>rr</b>er (czyt. kor<u>rer</u>) - biegać<br/>
el <b>r</b>ey (czyt. el rej) - król</td>
<td>Jak w języku polskim, ale jest to dźwięk trochę mocniejszy, bardziej wibrujący,
 zwłaszcza w słowach z podwójnym <i>r</i> (np. <i>el <u>per</u>ro</i> - pies).</td></tr>

<tr><td align="center"><h5>s</h5></td>
<td><i>ese</i></td>
<td><b>s</b>í (czyt. si) - tak<br/>
el <b>s</b>uelo (czyt. el <u>słe</u>lo) - podłoga</td>
<td>Jak w języku polskim.</td></tr>

<tr><td align="center"><h5>t</h5></td>
<td><i>te</i></td>
<td><b>t</b>arde (czyt. <u>tar</u>de) - późno<br/>
<b>t</b>rein<b>t</b>a (czyt. <u>trejn</u>ta) - trzydzieści</td>
<td>Jak w języku polskim.</td></tr>

<tr><td align="center"><h5>u</h5></td>
<td><i>u</i></td>
<td><b>ú</b>ltimo (czyt. <u>ul</u>timo) - ostatni<br/>
la m<b>ú</b>sica (czyt. la <u>mu</u>sika) - muzyka</td>
<td>Jak w języku polskim.</td></tr>

<tr><td align="center"><h5>v</h5></td>
<td><i>uve</i><br/>(lub <i>ve</i>)</td>
<td>la <b>v</b>entana (czyt. la <i>b</i>en<u>ta</u>na) - okno<br/>
la <b>v</b>erdad (czyt. la <i>b</i>er<u>dad</u>) - prawda</td>
<td>Dźwięk pośredni między polskimi <i>b</i> oraz <i>w</i> (identyczny jak
hiszpańskie <i>b</i>).</td></tr>

<tr><td align="center"><h5>w</h5></td>
<td><i>uve doble</i><br/>(też <i>ve doble</i> lub <i>doble ve</i>)</td>
<td>el <b>w</b>estern (czyt. el <u>łes</u>tern) - western<br/>
el <b>w</b>hisky (czyt. el <u>łis</u>ki) - whisky</td>
<td>Używana wyłącznie w słowach pochodzenia obcego. Wymawia się jak hiszpańskie <i>b</i> w
wielu nazwach własnych (jak np. <i>Walia</i>, <i>Wagner</i>, <i>Westfalia</i>)
lub też jak polskie <i>ł </i>w wyrazach pochodzenia angielskiego (np. <i>Washington</i>,
 <i>washingtoniano</i>).</td></tr>

<tr><td align="center"><h5>x</h5></td>
<td><i>equis</i></td>
<td>el te<b>x</b>to (czyt. el <u>teks</u>to) - tekst<br/>
la e<b>x</b>cepción (czyt. la eks<i>th</i>ep<i><u>th</u></i><u>jon</u>) - wyjątek </td>
<td>Jak w języku polskim.</td></tr>

<tr><td align="center"><h5>y</h5></td>
<td><i>i griega</i><br/>(lub <i>ye</i>)</td>
<td><b>y</b>o (czyt. <i>dzi</i>o) - ja<br/>
vo<b>y</b>(czyt. <i>b</i>oj) - idę<br/>
ma<b>y</b>o (czyt. <u>ma</u><i>dzi</i>o) - maj</td>
<td>Generalnie identyczna jak opisane wyżej złożenie liter <i>ll</i> (dźwięk pośredni między
polskimi <i>j</i> oraz <i>ź</i>), choć wymawia się też w niektórych przypadkach jak polskie
<i>j</i> (zwłaszcza gdy występuje na końcu wyrazu, np. <i>soy</i> - jestem) lub jak <i>i</i>
(jako spójnik <i>i</i> - po hiszpańsku <i>y</i>).</td></tr>

<tr><td align="center"><h5>z</h5></td>
<td><i>zeta</i><br/>(lub <i>zeda</i>)</td>
<td>el <b>z</b>apato (czyt. <i>th</i>a<u>pa</u>to) - but<br/>
el pe<b>z</b> (czyt. el pe<i>th</i>) - ryba <br/></td>
<td>Jak angielskie <i>th</i>w wyrazie <i>think</i> (język należy umieścić między zębami).
Jest to identyczny dźwięk jak opisany wyżej przy literze <i>c</i>.<br/>
W hiszpańskiej Andaluzji, na Wyspach Kanaryjskich oraz w
Ameryce Łacińskiej wymawia się jak <i>s</i>.</td></tr>
</table>
</SGrammarAlfabeto>
  );
};

export default GrammarAlfabeto;